import { useMemo } from "react";
import { _ } from "@sablier/v2-mixins";
import { queries } from "@sablier/v2-subgraphs";
import { IFilter } from "@sablier/v2-types";

export default function useRequestStreamListQuery(filter: IFilter) {
  const isIds = useMemo(
    () =>
      !_.isNil(filter.streamIds) &&
      !filter.streamIds.find((id) => _.isNilOrEmptyString(id)),
    [filter],
  );
  const isRecipient = useMemo(
    () => !_.isNilOrEmptyString(filter.recipient),
    [filter],
  );
  const isSender = useMemo(
    () => !_.isNilOrEmptyString(filter.sender),
    [filter],
  );

  return useMemo(() => {
    if (isSender && isRecipient && isIds) {
      return queries.getStreams_BySenderOrByRecipient_ByIds;
    }

    if (isSender && isRecipient) {
      return queries.getStreams_BySenderOrByRecipient;
    }

    if (isSender && isIds) {
      return queries.getStreams_BySender_ByIds;
    }

    if (isRecipient && isIds) {
      return queries.getStreams_ByRecipient_ByIds;
    }

    if (isIds) {
      return queries.getStreams_ByIds;
    }

    if (isRecipient) {
      return queries.getStreams_ByRecipient;
    }

    if (isSender) {
      return queries.getStreams_BySender;
    }

    return queries.getStreams;
  }, [isIds, isRecipient, isSender]);
}
